import * as api from 'dashboard/resources/announcements.api';
import { isActiveAnnouncement, isArchivedAnnouncement, isScheduledAnnouncement } from 'dashboard/reducers/announcements/utils';
import isEqual from 'lodash/isEqual';

import announcementTypes from './announcement-types';
import actionTypes from './action-types';

export const fetchAnnouncementsRequest = () => ({
  type: actionTypes.FETCH_ANNOUNCEMENTS_REQUEST,
  name: 'announcementsStatusLoadingStatus',
});

export const fetchAnnouncementsSuccess = ({ draft, items }, locale, lotteryTime) => ({
  type: actionTypes.FETCH_ANNOUNCEMENTS_SUCCESS,
  name: 'announcementsStatusLoadingStatus',
  draft,
  items,
  locale,
  lotteryTime,
});

export const fetchAnnouncementsFailure = () => ({
  type: actionTypes.FETCH_ANNOUNCEMENTS_FAILURE,
  name: 'announcementsStatusLoadingStatus',
});

export const fetchAnnouncements =
  (dashboard = false) =>
  async (dispatch, getState) => {
    try {
      const { config, session } = getState();
      const { locale, lotteryTime } = session;
      const { secondHandApproval, jurisdictionId } = config;
      const showOnlyPublishedWidgets = dashboard || !secondHandApproval;

      dispatch(fetchAnnouncementsRequest());
      const result = await api.fetchAnnouncements(showOnlyPublishedWidgets, jurisdictionId);
      dispatch(fetchAnnouncementsSuccess(result, locale, lotteryTime));
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('FETCH_ANNOUNCEMENTS', error);
      dispatch(fetchAnnouncementsFailure());
    }
  };

export const togglePinAnnouncements = (index) => (dispatch, getState) => {
  const { session, config } = getState();
  const { locale } = session;
  const { locales } = config;

  dispatch({
    type: actionTypes.TOGGLE_PIN_ANNOUNCEMENTS,
    index,
    locale,
    locales,
  });
};

export const deleteActiveAnnouncement = (index) => ({
  type: actionTypes.DELETE_ACTIVE_ANNOUNCEMENT,
  index,
});

export const deleteArchivedAnnouncement = (index) => ({
  type: actionTypes.DELETE_ARCHIVED_ANNOUNCEMENT,
  index,
});

export const deleteScheduledAnnouncement = (index) => ({
  type: actionTypes.DELETE_SCHEDULED_ANNOUNCEMENT,
  index,
});

export const deleteAnnouncement = (index, type) => (dispatch) => {
  switch (type) {
    case announcementTypes.ACTIVE:
      dispatch(deleteActiveAnnouncement(index));
      break;
    case announcementTypes.ARCHIVED:
      dispatch(deleteArchivedAnnouncement(index));
      break;
    case announcementTypes.SCHEDULED:
      dispatch(deleteScheduledAnnouncement(index));
      break;
    default:
      // eslint-disable-next-line no-console
      console.error('UNKNOWN ANNOUNCEMENT TYPE');
  }
};

export const addActiveAnnouncement = (announcement, locale) => ({
  type: actionTypes.ADD_ACTIVE_ANNOUNCEMENT,
  announcement,
  locale,
});

export const addArchivedAnnouncement = (announcement, locale) => ({
  type: actionTypes.ADD_ARCHIVED_ANNOUNCEMENT,
  announcement,
  locale,
});

export const addScheduledAnnouncement = (announcement, locale) => ({
  type: actionTypes.ADD_SCHEDULED_ANNOUNCEMENT,
  announcement,
  locale,
});

export const addAnnouncement = (announcement) => (dispatch, getState) => {
  const { session } = getState();
  const { lotteryTime, locale } = session;

  if (isActiveAnnouncement(announcement, lotteryTime)) {
    dispatch(addActiveAnnouncement(announcement, locale));
  } else if (isArchivedAnnouncement(announcement, lotteryTime)) {
    dispatch(addArchivedAnnouncement(announcement, locale));
  } else if (isScheduledAnnouncement(announcement, lotteryTime)) {
    dispatch(addScheduledAnnouncement(announcement, locale));
  }
};

export const updateAnnouncementsRequest = () => ({
  type: actionTypes.UPDATE_ANNOUNCEMENTS_REQUEST,
});

export const updateAnnouncementsSuccess = () => ({
  type: actionTypes.UPDATE_ANNOUNCEMENTS_SUCCESS,
});

export const updateAnnouncementsFailure = () => ({
  type: actionTypes.UPDATE_ANNOUNCEMENTS_FAILURE,
});

const getModifiedAnnouncements = (announcements, announcementsToUpdate, locale) => {
  // Find deleted announcements
  const deletedAnnoucments = announcements.filter(
    (announcement) => !announcementsToUpdate.find((announcementToUpdate) => announcementToUpdate.id === announcement.id)
  );

  // Find new aannouncements
  const newAnnouncements = announcementsToUpdate.filter((announcementToUpdate) => !announcementToUpdate.id);

  // Find updated announcements
  const updatedAnnouncements = announcementsToUpdate.filter((announcementToUpdate) =>
    announcements.find((announcement) => announcement.id === announcementToUpdate.id && !isEqual(announcementToUpdate, announcement))
  );

  return [...updatedAnnouncements, ...deletedAnnoucments, ...newAnnouncements].map((announcement) => announcement.fields[locale].title);
};

export const updateAnnouncements = () => async (dispatch, getState) => {
  try {
    const { session, config, announcements } = getState();
    const { locale } = session;
    const { locales, secondHandApproval, jurisdictionId } = config;
    const { active, scheduled, archived } = announcements;
    const announcementsToUpdate = [...active, ...scheduled, ...archived];
    const modified = getModifiedAnnouncements(announcements.items, announcementsToUpdate, locale);

    dispatch(updateAnnouncementsRequest());
    await api.updateAnnouncements(announcementsToUpdate, modified, locales, secondHandApproval, jurisdictionId);
    dispatch(updateAnnouncementsSuccess());
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('UPDATE_ANNOUNCEMENTS', error);
    dispatch(updateAnnouncementsFailure());
  }
};



// WEBPACK FOOTER //
// ./src/modules/dashboard/actions/announcements/announcements.actions.js